import qs from 'qs';
import { network } from 'services/network';

export const getPasswordPattern = (params) => {
    const { email, token } = params;
    const queryString = qs.stringify({ email }, { addQueryPrefix: true, skipNulls: true });
    const url = `admin/bo/getPasswordPattern${queryString}`;
    return network
        .post(url, null, {
            transformRequest: [
                (data, headers) => {
                    if (headers && token) {
                        headers.Authorization = `Bearer ${token}`;
                    }
                    return data;
                },
            ],
        })
        .then((response) => {
            return response.data;
        });
};
